export default __webpack_public_path__ + "static/media/MetaStemma.8c1ab0b2.png";